import { useMediaQuery } from './use-media-query.js';

/** Returns true when viewport width is ≤768px — the DataTable mobile breakpoint. */
export function useIsTableMobile(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
